import SmartTable from "../../../global/components/table/table.vue";
import getTableApi from "../../../const/TableApis";
import WorkflowfolgeclientfunktionenModalCreate from "../WorkflowfolgeclientfunktionenModalCreate/WorkflowfolgeclientfunktionenModalCreate.vue";
import PageTabTitle from "../../../global/components/PageTabTitle/PageTabTitle.vue";

const TABLE_ID = "workflowfolgeclientfunktion";

// @vue/component
export default {
  name: "WorkflowfolgeclientfunktionenList",
  components: {
    SmartTable,
    WorkflowfolgeclientfunktionenModalCreate,
    PageTabTitle,
  },
  data() {
    return {
      tableId: TABLE_ID,
      options: {
        id: TABLE_ID,
        url: getTableApi({ id: TABLE_ID }),
        rowActions: [
          {
            label: this.$gettext("Details anzeigen"),
            route: "root.workflowfolgeclientfunktionen.detail",
            routeParameters: [{ routeId: "id", rowPath: "pk" }],
          },
        ],
        actions: [
          {
            label: this.$gettext("Neue Clientfunktion erstellen"),
            callback: () => this.modal.create = true,
            permission: "clientfunktion.create",
            type: "button",
            className: "btn btn-primary",
            icon: "glyphicon-plus",
            htmlId: "clientfunktion_create",
          },
        ],
        label: "Clientfunktionen",
        pagination: true,
        details: false,
        view: {
          filter: "top",
        },
      },
      modal: {
        create: undefined,
      },
    };
  },
  methods: {
    closeModalCreate() {
      this.modal.create = false;
    },
  },
};
